module.exports = __webpack_public_path__ + "media/images/components/map-icons/contacts-map-pin-co_candidate-e2e73aaeaa28b8af034ce082d7f99704.png";